









import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {formatPrice} from "@/utils/formatters";

    declare const $: any;

    @Component({})
    export default class ObjektiCard2TabZalihe extends Vue {
        @Prop({default: false}) isBusyLoadingStock!: boolean;
        @Prop() stock!: [];

        tableColumns = [];

        tableOptions = {
            pagination: true,
            pageSize: 25,
        }

        created() {
            this.tableColumns = [
                {field: 'product', title: this.$i18n.t('artikal')},
                //{field: 'quantity', width: 30, title: this.$i18n.t('kol'), align: 'right'},
                {field: 'price', width: 30, title: this.$i18n.t('cena'), align: 'right', formatter: (value) => formatPrice(value)},
                {field: 'stockInWarehouse', width: 30, title: this.$i18n.t('zaliha'), align: 'right'},
            ];
        }

        @Watch('isBusyLoadingStock') isBusyChange(value) {
          let table = $(this.$refs.table);
          if (value) {
              table.bootstrapTable('showLoading');
          } else {
              table.bootstrapTable('hideLoading');
          }
        }
    }
